import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import cn from 'classnames'
import { Container } from 'ui/container'
import { PageTitle } from '../../features/common/page-title'
import { Banner as TasksBanner } from 'features/tasks/banner'
import { List as TasksList } from 'features/tasks/list'
import { ReferralContent } from 'features/friends/referral-content'
import { useAuthContext } from '../../core/providers/AuthProvider'
import c from './assets/sass/page.module.scss'

const EarningsPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { updateUserData } = useAuthContext()
    const [activeTab, setActiveTab] = useState('tasks')

    const handleFAQ = () => {
        navigate(`/faq?category=${activeTab === 'tasks' ? 'tasks' : 'referrals'}`)
    }

    return (
        <div className={c.component}>
            <PageTitle title={t('pages.earnings.title')} callback={handleFAQ} />
            <Container>
                <div className={c.tabs}>
                    <button
                        className={cn(c.tab, { [c.active]: activeTab === 'tasks' })}
                        onClick={() => setActiveTab('tasks')}
                    >
                        {t('pages.earnings.tabTasks')}
                    </button>
                    <button
                        className={cn(c.tab, { [c.active]: activeTab === 'referrals' })}
                        onClick={() => setActiveTab('referrals')}
                    >
                        {t('pages.earnings.tabReferrals')}
                    </button>
                </div>

                {activeTab === 'tasks' ? (
                    <>
                        <TasksBanner />
                        <TasksList onTaskComplete={updateUserData} />
                    </>
                ) : (
                    <ReferralContent />
                )}
            </Container>
        </div>
    )
}

export default EarningsPage
